<template>
    <div class="breadcrumbs_wrap">
        <div class="breadcrumbs">
            <i class="material-icons element-icon">edit</i>
            <router-link :to="'/editor/'+adventureId">{{textTools.parseTitle(adventure.name,"Adventure")}}</router-link>
            <i class="material-icons">keyboard_arrow_right</i>
            <i class="material-icons element-icon" v-if="chapterId">collections_bookmark</i>
            <router-link :to="'/editor/'+adventureId+'/chapters/'+chapterId" v-if="chapterId">{{textTools.parseTitle(chapter.name,"Chapter")}}</router-link>
            <i class="material-icons" v-if="stageId">keyboard_arrow_right</i>
            <i class="material-icons element-icon" v-if="stageId">nature_people</i>
            <router-link :to="'/editor/'+adventureId+'/chapters/'+chapterId+'/stages/'+stageId" v-if="stageId">{{textTools.parseTitle(stage.name,"Stage")}}</router-link>
            <i class="material-icons" v-if="objectId">keyboard_arrow_right</i>
            <i class="material-icons element-icon" v-if="objectId">widgets</i>
            <router-link :to="'/editor/'+adventureId+'/chapters/'+chapterId+'/objects/'+objectId" v-if="objectId">{{textTools.parseTitle(object.name,"Object")}}</router-link>
            <i class="material-icons" v-if="timelineLocation">keyboard_arrow_right</i>
            <i class="material-icons element-icon" v-if="timelineLocation">device_hub</i>
            <router-link :to="'/editor/'+adventureId+'/chapters/'+chapterId+'/timeline'" v-if="timelineLocation">Timeline</router-link>
        </div>
    </div>
</template>
<style>
.breadcrumbs_wrap{
    height: 32px;
    width:100%; 
    padding: 0;
    background-color: #999; 
    padding-top: 7.5px;
    padding-left: 24px;
}
.breadcrumbs{
    text-align: left;
    overflow: visible;
    position: relative;
    margin: auto;
    max-width: 1024px;
    font-weight: 600;
    color: #ececec;
}
.breadcrumbs i{
    position: relative;
    top: -2px !important;
}
.breadcrumbs i.element-icon{
    font-size: 14px;
    top: -7.5px !important;
}
.breadcrumbs a{
    position: relative;
    color: inherit; /* blue colors for links too */
    text-decoration: inherit; /* no underline */
    font-weight: bold;
    top: -9px !important;
}

</style>
<script>
import TextTools from './TextTools.js';

export default{
    data: () => ({
        'textTools': {}
    }),
    created(){
        this.textTools = TextTools;
    },
    props: [
        'adventure', 'adventureId', 
        'chapter', 'chapterId', 
        'stage', 'stageId',
        'object', 'objectId',
        'timelineLocation'
    ]
}
</script>


// WEBPACK FOOTER //
// Breadcrumbs.vue?46955d50